import $ from 'jquery';

const imageSlider = () => {
  $('.slider-image-relative').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
  });

  $('.sku-repeater').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          infinite: false,
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  });
};

export default imageSlider;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/stetson-europe-chisel/src/scripts/additional/image-slider.js